export const useConfig = () => {
  const configCookie = {
    nameLocale: import.meta.env.VITE_COOKIE_NAME_LOCALE || 'APP_LOCALE',
    nameUtmSource: import.meta.env.VITE_COOKIE_NAME_UTM_SOURCE || 'META_UTM_SOURCE',
  };

  return { configCookie };
};
